<template>
  <div class="video-wrapper">
    <div v-if="isSelf && mainScreenData && mainScreenData.cameraStatus !== 0" class="mainscreen-self" :id="selfContainerId"></div>
    <div v-else-if="isSelf && (!mainScreenData || mainScreenData.cameraStatus === 0)" class="mainscreen-bg">
      <img class="mainscreen-bg-img" :src="mainScreenData && mainScreenData.userInfo && mainScreenData.userInfo.headPortrait" alt="" />
    </div>
    <div v-else-if="!isSelf && mainScreenData && mainScreenData.cameraStatus !== 0" class="mainscreen-pull">
      <video
        class="zb-video"
        :id="playerId"
        preload="auto"
        playsinline
        webkit-playsinline
        style="object-fit: cover;"
      ></video>
      <div class="mainscreen-video-cover" v-if="!isPlaying">
        <div class="mainscreen-video-cover-box">
          <img class="mainscreen-video-cover-img" :src="mainScreenData && mainScreenData.userInfo && mainScreenData.userInfo.headPortrait" alt="" />
        </div>
      </div>
    </div>
    <div v-else class="mainscreen-bg">
      <img class="mainscreen-bg-img" :src="mainScreenData && mainScreenData.userInfo && mainScreenData.userInfo.headPortrait" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "mainscreenplayer",
  props: {
    mainScreenData: {
      type: Object,
      default: null
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    selfUserId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      player: null,
      playerId: null,
      selfContainerId: null,
	  isPlaying:false,
      licenseUrl: "https://1383640469.sdk-license.com/license/v2/1383640469_1/v_cube.license"
    };
  },
  mounted() {
	console.log(this.mainScreenData,'mainScreenData')
    if (this.isSelf && this.selfUserId) {
      this.selfContainerId = 'pusher-' + this.selfUserId;
    } else {
      this.playerId = 'mainscreen-player-' + Date.now();
      this.$nextTick(() => {
        this.initPlayer();
      });
    }
  },
  watch: {
    mainScreenData: {
      immediate: true,
      handler(newVal) {
        if (newVal && !this.isSelf) {
          this.$nextTick(() => {
            this.initPlayer();
          });
        }
      }
    }
  },
  beforeDestroy() {
    if (this.player) {
      try {
        this.player.pause();
        this.player.src('');
        this.player.dispose();
      } catch (e) {
        console.warn('播放器清理异常:', e);
      }
      this.player = null;
    }
  },
  methods: {
    initPlayer() {
      if (!this.mainScreenData || !this.mainScreenData.pullUrl || this.mainScreenData.cameraStatus === 0) return;
      
      if (!this.playerId) {
        this.playerId = 'mainscreen-player-' + Date.now();
      }
      
      this.$nextTick(() => {
        if (!document.getElementById(this.playerId)) {
          console.warn('播放器容器不存在:', this.playerId);
          return;
        }
        
        if (!this.player) {
          this.player = TCPlayer(this.playerId, {
            sources: [{
              src: this.mainScreenData.pullUrl
            }],
            licenseUrl: this.licenseUrl,
            autoplay: true,
            controls: false,
            playsinline: true,
            posterImage: false,
            bigPlayButton: false,
            webrtcConfig: {
              connectRetryCount: 999999
            }
          });
          
          this.player.on('webrtcevent', (event) => {
            console.log('mainscreen webrtcevent:', event.data);
            if (event.data.code == 1005 || event.data.code == 1009) {
              this.isPlaying = false;
            }
            if (event.data.code == 1003) {
              this.isPlaying = true;
            }
          });
          
          this.player.on('play', () => {
            this.isPlaying = true;
          });
          
          this.player.on('playing', () => {
            this.isPlaying = true;
          });
          
          this.player.on('loadeddata', () => {
            this.isPlaying = true;
          });
          
          setTimeout(() => {
            if (!this.isPlaying) {
              this.isPlaying = true;
            }
          }, 500);
        } else {
          this.player.src(this.mainScreenData.pullUrl);
          this.player.play();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.video-wrapper {
  height: 100%;
  aspect-ratio: 9 / 16;
  position: relative;
  overflow: hidden;
}

.mainscreen-self {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 98;
}

.mainscreen-pull {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.mainscreen-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mainscreen-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.zb-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 98;
}

.mainscreen-video-cover {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 97;
}

.mainscreen-video-cover-box {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mainscreen-video-cover-img {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
<style>
.video-wrapper video {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.video-wrapper video::-webkit-media-controls {
  display: none !important;
}

.video-wrapper video::-webkit-media-controls-enclosure {
  display: none !important;
}

.video-wrapper video::-webkit-media-controls-panel {
  display: none !important;
}

.video-wrapper button,
.video-wrapper .vjs-big-play-button,
.video-wrapper .tcp-big-play-button,
.video-wrapper .vjs-control-bar {
  display: none !important;
  pointer-events: none !important;
}
</style>


// WEBPACK FOOTER //
// mainscreenplayer.vue?ebe526de